import { Model } from './model';

export class PaymentMethod extends Model {
  paymentMethodId: string;
  paymentMethodType: string;
  cardNumber: string;
  cardExpire: string;
  cardBrand: string;
  bankCode: string;
  country: string;
  mandateUrl: string;

  afterDeserialize(input: any) {
    if (input['payment-method-id']) {
      this.paymentMethodId = input['payment-method-id'];
    }
    if (input['payment-method-type']) {
      this.paymentMethodType = input['payment-method-type'];
    }
    if (input['card-number']) {
      this.cardNumber = input['card-number'];
    }
    if (input['card-expire']) {
      this.cardExpire = input['card-expire'];
    }
    if (input['card-brand']) {
      this.cardBrand = input['card-brand'];
    }
    if (input.type && !this.cardBrand) {
      this.cardBrand = input.type;
    }
    if (input['bank-code']) {
      this.bankCode = input['bank-code'];
    }
    if (input['mandate-url']) {
      this.mandateUrl = input['mandate-url'];
    }
  }
}

export class KeyValue extends Model {
  key: string;
  value: boolean;
}

export class PropertiesPaymentMethod extends Model {
  property1: KeyValue;
  property12: KeyValue;
}

export class PaymentData extends Model {
  userEnabledPaymentMethods: PropertiesPaymentMethod;
  cartEnabledPaymentMethods: PropertiesPaymentMethod;
  paymentGateways: Array<string>;
}

export class PaypalCreate extends Model {
  paymentId: string;
}
